import { useCallback } from "react";
import { useModal } from "@/context/ModalContext";

interface UseModalStateReturn {
    isOpen: (id: string) => boolean;
    setModalId: (id: string) => void;
    modalId: string;
    modalContent: any;
    setModalContent: (content: any) => void;
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;
}

// Setting the modal state of global modals
const useModalState = (): UseModalStateReturn => {
    const { setModalId, modalId, modalContent, setModalContent, isLoading, setIsLoading } = useModal();

    /**
     * Function to set global modal
     *
     * @param id Id of the global modal to be opened
     * @returns returns true/false
     *
     */
    const isOpen = useCallback((id: string): boolean => id === modalId, [modalId]);

    return { isOpen, setModalId, modalId, modalContent, setModalContent, isLoading, setIsLoading };
};

export default useModalState;
